import React, { memo } from 'react';
import * as Styled from './styled';

const PlanDetailLane = ({ children, title, subTitle, textLink, textAction, onlyTitle }) => (
  <Styled.Wrapper>
    <Styled.Header>
      <Styled.Title>
        <strong>{title}</strong>
        {!onlyTitle && <p>{subTitle}</p>}
      </Styled.Title>
      {!onlyTitle && children}
    </Styled.Header>
    {onlyTitle && children}
    {!onlyTitle && textLink && <Styled.Link onClick={textAction}> {textLink} </Styled.Link>}
  </Styled.Wrapper>
);

export default memo(PlanDetailLane);